import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col,
    Card
} from "reactstrap";
import React, { useState } from 'react';
import styles from './styles.module.scss';
import DownCaret from '/public/site-assets/svg/down-caret.svg';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Arrow from '/public/site-assets/svg/right-arrow.svg';

export default function TabTestimonial({
    global,
    pathPrefix,
    customClass = "",
    heading,
    content,
    column1Text,
    column2Text,
    column3Text,
    testimonial1,
    testimonial2,
    postOrder = false
}) {

    const slider = React.useRef(null);
    var settings = {
        autoplay: false,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 6500,
        fade: true,
        cssEase: 'linear',
        adaptiveHeight: true
    };
    return (
        <section className={`${styles.root} ${customClass}`}>
            <Container>
                <div className="text-center">
                    <SourceFlowText global={global} path={`${pathPrefix}.heading`} type="html">
                        {heading}
                    </SourceFlowText>
                </div>
                {content ?
                    <>
                        <div className="content-wrapper p-lg-5 p-4 rounded-3 mt-5 position-relative">
                            <SourceFlowText global={global} path={`${pathPrefix}.content`} type="html">
                                {content}
                            </SourceFlowText>
                        </div>
                        <div className="text-center mt-5 mb-4">
                            <span className="arrow d-inline-block position-relative">
                                <DownCaret />
                            </span>
                        </div></> : ""}

                <Tabs>
                    <TabList className={`${content ? "react-tabs__tab-list" : "react-tabs__tab-list mb-4"}`}>
                        <Tab>
                            <div className="column-wrapper p-3 p-md-4 rounded-3">
                                <h6 className="mb-0">
                                    <strong>
                                        <SourceFlowText global={global} path={`${pathPrefix}.column1Text`}>
                                            {column1Text}
                                        </SourceFlowText>
                                    </strong>
                                </h6>
                            </div>
                        </Tab>
                        <div className="p-lg-5 p-4 text-center">
                            <strong><SourceFlowText global={global} path={`${pathPrefix}.column2Text`}>
                                {column2Text}
                            </SourceFlowText></strong>
                        </div>
                        <Tab><div className="column-wrapper p-3 p-md-4 rounded-3">
                            <h6 className="mb-0">
                                <strong>
                                    <SourceFlowText global={global} path={`${pathPrefix}.column3Text`}>
                                        {column3Text}
                                    </SourceFlowText>
                                </strong>
                            </h6>
                        </div></Tab>
                    </TabList>
                    {content ?
                        <>
                            <div className="text-center mt-4 mb-4">
                                <span className="arrow d-inline-block position-relative">
                                    <DownCaret />
                                </span>
                            </div>
                        </> : ""
                    }

                    <TabPanel>
                        <Slider ref={slider} {...settings}>
                            {testimonial1?.map((post, index) => (
                                <Card key={index}>
                                    <Row>
                                        <Col lg={7} className="mb-4 mb-lg-0">
                                            <div className={`imageWrapper${postOrder ? "-enable-order" : ""}`}>
                                                {postOrder ?
                                                    <span className="position-absolute order">{post.order}</span> : ""}
                                                <SourceFlowImage
                                                    src={post.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                    size="1000x1000"
                                                    alt={post?.title}
                                                    className="card-img rounded-3"
                                                    width="100%"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="testimonial-body rounded-3 p-3 p-md-5 h-100">
                                                {testimonial1.length >= 2 && (
                                                    <div className="d-inline-flex flex-nowrap custom-arrow-wrapper position-relative">
                                                        <button className="custom-arrow prev" onClick={() => slider?.current?.slickPrev()}><Arrow /></button>
                                                        <button className="custom-arrow next" onClick={() => slider?.current?.slickNext()}><Arrow /></button>
                                                    </div>
                                                )}
                                                <h6 className="text-white mt-4 mb-4"><strong>{post?.title}</strong></h6>
                                                {post?.content ?
                                                    <div className="description text-white position-relative" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                    : ""}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>

                            ))}
                        </Slider>
                    </TabPanel>
                    <TabPanel>
                        <Slider ref={slider} {...settings}>
                            {testimonial2?.map((post, index) => (
                                <Card key={index}>
                                    <Row>
                                        <Col lg={7} className="mb-4 mb-lg-0">
                                            <div className={`imageWrapper${postOrder ? "-enable-order" : ""}`}>
                                                {postOrder ?
                                                    <span className="position-absolute order">{post.order}</span> : ""}
                                                <SourceFlowImage
                                                    src={post?.image ? post.image : "/site-assets/images/image-placeholder.webp"}
                                                    size="1000x1000"
                                                    alt={post?.title}
                                                    className="card-img rounded-3"
                                                    width="100%"
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={5}>
                                            <div className="testimonial-body rounded-3 p-5 h-100">
                                                {testimonial2.length >= 2 && (
                                                    <div className="d-inline-flex flex-nowrap custom-arrow-wrapper position-relative">
                                                        <button className="custom-arrow prev" onClick={() => slider?.current?.slickPrev()}><Arrow /></button>
                                                        <button className="custom-arrow next" onClick={() => slider?.current?.slickNext()}><Arrow /></button>
                                                    </div>
                                                )}
                                                <h6 className="text-white mt-4 mb-4"><strong>{post?.title}</strong></h6>
                                                {post?.content ?
                                                    <div className="description text-white position-relative" dangerouslySetInnerHTML={{ __html: post?.content }} />
                                                    : ""}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            ))}
                        </Slider>
                    </TabPanel>
                </Tabs>

            </Container>
        </section>
    )
}